<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="saveModal"
      size="lg"
      body-class="position-static"
      centered
      :title="isCreated ? 'Thêm mới' : 'Cập nhật'"
      no-close-on-backdrop
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="admissionRoundId">
              <template v-slot:label>
                Đợt xét tuyển <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Đợt xét tuyển"
                rules="required"
              >
                <v-select
                  v-model="targetItem.admissionRoundId"
                  :options="admissionRounds"
                  :reduce="option => option.value"
                  @input="readAdmissionForm"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="admissionFormId">
              <template v-slot:label>
                Phương thức xét tuyển <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Phương thức xét tuyển"
                rules="required"
              >
                <v-select
                  v-model="targetItem.admissionFormId"
                  :options="dataListAdmissionForm"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="factAdmissionCriteriaTypeId">
              <template v-slot:label>
                Loại tiêu chí
              </template>
                <v-select
                  v-model="targetItem.factAdmissionCriteriaTypeId"
                  :options="dataAdmissionCriteriaTypes"
                  :reduce="option => option.value"
                  @input="selectCriteriaTypeId"
                />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="factAdmissionLanguageCertificateTypeId">
              <template v-slot:label>
                Loại chứng chỉ ngoại ngữ <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Loại chứng chỉ ngoại ngữ "
                rules="required"
              >
                <v-select
                  v-model="targetItem.factAdmissionLanguageCertificateTypeId"
                  :options="dataListLanguageCertificateType"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="criteriaSetId">
              <template v-slot:label>
                Áp dụng cho bộ tiêu chí
              </template>
              <v-select
                v-model="targetItem.criteriaSetId"
                :options="criteriaSets"
                :reduce="option => option.value"
                @input="selectCriteriaSet"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="criteriaId">
              <template v-slot:label>
                Áp dụng cho tiêu chí
              </template>
              <v-select
                v-model="targetItem.criteriaId"
                :options="criterias"
                :reduce="option => option.value"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="acceptScore">
              <template v-slot:label>
                Điểm chấp nhận/tối thiểu chứng chỉ ngoại ngữ <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Điểm chấp nhận/tối thiểu chứng chỉ ngoại ngữ"
                rules="required"
              >
                <b-form-input
                  id="acceptScore"
                  v-model="targetItem.acceptScore"
                  name="acceptScore"
                  placeholder="Điểm chấp nhận/tối thiểu chứng chỉ ngoại ngữ"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="maxAcceptScore">
              <template v-slot:label>
                Điểm chứng chỉ ngoại ngữ tối đa
              </template>
                <b-form-input
                  id="acceptScore"
                  v-model="targetItem.maxAcceptScore"
                  name="acceptScore"
                  placeholder="Điểm chứng chỉ ngoại ngữ tối đa"
                />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="yearNum">
              <template v-slot:label>
                Số năm từ lúc cấp chứng chỉ <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Số năm từ lúc cấp chứng chỉ"
                rules="required"
              >
                <b-form-input
                  id="yearNum"
                  v-model="targetItem.yearNum"
                  name="yearNum"
                  placeholder="Số năm từ lúc cấp chứng chỉ"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetItem.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('saveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton, BCol, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BModal, BOverlay, BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'

export default {
  name: 'Save',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      targetItem: {
        admissionRoundId: null,
        admissionFormId: null,
        factAdmissionLanguageCertificateTypeId: null,
        acceptScore: null,
        yearNum: null,
        factAdmissionCriteriaTypeId: null,
        criteriaSetId: null,
        criteriaId: null,
        maxAcceptScore: null,
        status: 1,
      },
      criteriaSets: [],
      criterias: [],
      required,
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'admissionRound/statuses',
      admissionRounds: 'admissionRound/admissionRoundsByOrganization',
      dataListAdmissionForm: 'admissionForm/admissionFormByAdmissionRoundId',
      dataCriteriaSet: 'criteriaSet/criteriaSetByType',
      criteria: 'criteria/criteria',
      dataAdmissionCriteriaTypes: 'factAdmissionCriteriaType/dataAdmissionCriteriaTypes',
      dataListLanguageCertificateType: 'factAdmissionLanguageCertificateType/dataListLanguageCertificateType',
    }),
    statusOptions() {
      return this.statuses
    },
    isCreated() {
      return !this.item
    },
  },
  methods: {
    ...mapActions({
      createAdmissionLanguageScores: 'admissionLanguageScore/createAdmissionLanguageScores',
      updateAdmissionLanguageScores: 'admissionLanguageScore/updateAdmissionLanguageScores',
      readAdmissionFormByAdmissionRoundId: 'admissionForm/readAdmissionFormByAdmissionRoundId',
      getAdmissionRoundsByOrganization: 'admissionRound/readAdmissionRoundsByOrganization',
      getLanguageCertificateType: 'factAdmissionLanguageCertificateType/getLanguageCertificateType',
      getAdmissionCriteriaTypes: 'factAdmissionCriteriaType/getAdmissionCriteriaTypes',
      getCriteriaSetByTypeId: 'criteriaSet/getListByTypeId',
      getCriteria: 'criteria/getCriteria',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      await this.getAdmissionCriteriaTypes()
      await this.getAdmissionRoundsByOrganization({ organizationId: getUser().orgId })
      await this.getLanguageCertificateType()
      if (this.item) {
        this.targetItem = { ...this.item }
      }
      await this.selectCriteriaTypeId()
      await this.selectCriteriaSet(this.targetItem.criteriaSetId)
      await this.readAdmissionFormByAdmissionRoundId({ admissionRoundId: this.targetItem.admissionRoundId})
    },
    async readAdmissionForm(id) {
      await this.readAdmissionFormByAdmissionRoundId({ admissionRoundId: id })
    },
    async selectCriteriaTypeId() {
      await this.getCriteriaSetByTypeId({
        admissionRoundId: this.targetItem.admissionRoundId,
        admissionFormId: this.targetItem.admissionFormId,
        factAdmissionCriteriaTypeId: this.targetItem.factAdmissionCriteriaTypeId
      })
      this.criteriaSets = this.dataCriteriaSet.map(item => ({ value: item.id, label: item.name }))
    },
    async selectCriteriaSet(id) {
      await this.getCriteria({
        criteriaSetId: id
      })
      this.criterias = this.criteria.map(item => ({ value: item.id, label: item.name }))
    },
    onHide() {
      this.$refs
        .saveFormRef
        .reset()
      this.targetItem = {
        admissionRoundId: null,
        admissionFormId: null,
        factAdmissionLanguageCertificateTypeId: null,
        acceptScore: null,
        yearNum: null,
        factAdmissionCriteriaTypeId: null,
        criteriaSetId: null,
        criteriaId: null,
        maxAcceptScore: null,
        status: 1,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .saveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createAdmissionLanguageScores(this.targetItem)
            : await this.updateAdmissionLanguageScores(this.targetItem)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('saveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
